module.exports = __webpack_public_path__ + "static/17.2-3153a29116d5dcef8ad4758fa36b6a3e.jpg";